import React, { useEffect, useState, useCallback, createContext } from "react";
import TabPanel from "../TabPanel/TabPanel";
import { Grid } from "@mui/material";
import { MultipleTabsProps, State } from "./interfaces";
import { Container } from "./styles";
import MultipleTabsPortal from "./MultipleTabsPortal";

interface Context {
  maxDisplayedTabs: number;
}

export const MultipleTabsContext = createContext<Context>({
  maxDisplayedTabs: 0,
});

const MultipleTabs = ({ panels, selectedTab, maxDisplayedTabs }: MultipleTabsProps) => {
  const [value, setValue] = useState<number>(
    selectedTab !== undefined && selectedTab !== -1 && selectedTab < panels?.length ? selectedTab : 0
  );

  useEffect(() => {
    const useTabIndex =
      selectedTab !== undefined && selectedTab !== -1 && selectedTab < panels?.length ? selectedTab : 0;
    if (useTabIndex >= 0) setValue(useTabIndex);
  }, [selectedTab, panels?.length]);

  const handleChangeValue = useCallback((value: number) => {
    setValue(value);
  }, []);

  return (
    <MultipleTabsContext.Provider
      value={{
        maxDisplayedTabs: maxDisplayedTabs ?? 4,
      }}
    >
      <Container>
        <MultipleTabsPortal
          panels={panels}
          value={value}
          handleChangeValue={handleChangeValue}
        />
        {panels.map(({ tabPanelComponent }, idx) => (
          <TabPanel
            key={idx}
            value={value}
            index={idx}
          >
            {tabPanelComponent}
          </TabPanel>
        ))}
      </Container>
    </MultipleTabsContext.Provider>
  );
};

export default MultipleTabs;
